import { RegisterForm } from './register-form';

export function initAcmeAddOrganizationForm(): void {
    document.querySelectorAll<HTMLFormElement>('.js-acme-add-organization-form').forEach($form => {
        new AcmeAddOrganizationForm($form);
    });
}

class AcmeAddOrganizationForm {
    private readonly $form: HTMLFormElement;
    private readonly $isRequestedForMyEntityRadios: NodeListOf<HTMLInputElement>|null = null;
    private readonly $containersIfIsRequestedForMyEntity: NodeListOf<HTMLElement>|null = null;
    private readonly $containersIfIsNotRequestedForMyEntity: NodeListOf<HTMLElement>|null = null;

    constructor($form: HTMLFormElement) {
        this.$form = $form;

        new RegisterForm(this.$form, {
            validateFieldsOnSubmit: false,
            allowPrefilledEntityModifications: false,
            entityIdentifierOptions: {
                allowExistingThirdparties: true,
            },
        });

        this.$isRequestedForMyEntityRadios = this.$form.querySelectorAll<HTMLInputElement>('#add_organization_form_requested_for_my_entity input');
        this.$containersIfIsRequestedForMyEntity = this.$form.querySelectorAll<HTMLElement>('.js-show-if-is-requested-for-my-entity');
        this.$containersIfIsNotRequestedForMyEntity = this.$form.querySelectorAll<HTMLElement>('.js-show-if-is-not-requested-for-my-entity');

        this.doEvents();
    }

    /**
     * Do entity events
     * 
     * @return {void}
     */
    private doEvents() : void {
        if (this.$isRequestedForMyEntityRadios?.length) {
            this.onIsRequestedForMyEntityRadioChange();

            this.$isRequestedForMyEntityRadios.forEach($radio => {
                $radio.addEventListener('change', () => this.onIsRequestedForMyEntityRadioChange());
            });
        }
    }

    /**
     * On isRequestedForMyEntityRadios change event
     * 
     * @return {void}
     */
    private onIsRequestedForMyEntityRadioChange() : void {
        this.$isRequestedForMyEntityRadios?.forEach($radio => {
            if (!$radio.checked) {
                return;
            }

            if ('yes' === $radio.value) {
                this.$containersIfIsRequestedForMyEntity?.forEach($container => $container.classList.remove('hidden'));
                this.$containersIfIsNotRequestedForMyEntity?.forEach($container => $container.classList.add('hidden'));
            } else {
                this.$containersIfIsNotRequestedForMyEntity?.forEach($container => $container.classList.remove('hidden'));
                this.$containersIfIsRequestedForMyEntity?.forEach($container => $container.classList.add('hidden'));
            }
        });
    }
}
